import { render } from "./key_search.vue?vue&type=template&id=d56004e8&scoped=true"
import script from "./key_search.vue?vue&type=script&lang=js"
export * from "./key_search.vue?vue&type=script&lang=js"

import "./key_search.vue?vue&type=style&index=0&id=d56004e8&scoped=true&lang=css"
import "./key_search.vue?vue&type=style&index=1&id=d56004e8&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d56004e8"]])

export default __exports__